import { Alert, Box, Link } from '@mui/material';
import React from 'react';
const INFO_PARSE_CODES = ['matched_by_meter_id'];
export const MAPPING_PARSE_CODES = ['unit_meter_conflict', 'unit_name_not_mapped', 'meter_id_not_mapped', 'meter_id_on_several_units', 'unit_name_on_several_units'];
const renderMessages = messages => /*#__PURE__*/React.createElement(Box, {
  sx: {
    maxHeight: 160,
    overflowY: 'auto'
  }
}, messages.map((warning, idx) => /*#__PURE__*/React.createElement("div", {
  key: idx
}, warning.rowIndex > 0 ? "Row ".concat(warning.rowIndex, ": ").concat(warning.message) : warning.message)));
export const ParseWarnings = _ref => {
  let warnings = _ref.warnings,
    onFixMapping = _ref.onFixMapping,
    _ref$isFixMappingLoad = _ref.isFixMappingLoading,
    isFixMappingLoading = _ref$isFixMappingLoad === void 0 ? false : _ref$isFixMappingLoad;
  if (warnings.length === 0) return null;
  const infos = warnings.filter(w => INFO_PARSE_CODES.includes(w.code));
  const problems = warnings.filter(w => !INFO_PARSE_CODES.includes(w.code));
  const hasMappingProblem = problems.some(w => MAPPING_PARSE_CODES.includes(w.code));
  return /*#__PURE__*/React.createElement(React.Fragment, null, problems.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    sx: {
      mb: 2
    }
  }, renderMessages(problems), hasMappingProblem && onFixMapping && /*#__PURE__*/React.createElement(Link, {
    component: "button",
    type: "button",
    variant: "body2",
    onClick: onFixMapping,
    disabled: isFixMappingLoading,
    sx: {
      mt: 1,
      display: 'block',
      color: 'primary.main',
      fontWeight: 600,
      textDecoration: 'underline',
      '&:disabled': {
        opacity: 0.5,
        cursor: 'default'
      }
    }
  }, "Fix the mapping in the utility setup")), infos.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      mb: 2
    }
  }, renderMessages(infos)));
};